import { render, staticRenderFns } from "./ButtonBack.vue?vue&type=template&id=169c4f60"
import script from "./ButtonBack.vue?vue&type=script&lang=js"
export * from "./ButtonBack.vue?vue&type=script&lang=js"
import style0 from "./ButtonBack.vue?vue&type=style&index=0&id=169c4f60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports